<template>
  <div class="background">
    <div class="content blur">
      <p></p>
    </div>
    <div class="content not-blur">
      <h1>在&nbsp;&nbsp; 线  &nbsp;&nbsp;考  &nbsp;&nbsp;试  &nbsp;&nbsp;系  &nbsp;&nbsp;统</h1>
      <el-divider class="divider"></el-divider>
      <div class="formDiv">
        <el-form :model="userinfo" :rules="userLoginRule" ref="loginForm">
          <el-form-item prop="userName">
            <el-input type="text" v-model.trim="userinfo.userName" clearable placeholder="请输入用户名" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model.trim="userinfo.password" clearable @keyup.enter.native="login()" show-password placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <div class="error">{{errorMsg}}</div>
          <el-form-item>
            <div class="form_btn_div">
              <el-button type="primary" @click="login()" class="loginFormButton">登录</el-button>
              <el-button type="warning" @click="openRegistDrawer()" class="loginFormButton">注册</el-button>
            </div>

          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-drawer title="用户注册" :before-close="handleCloseRegistForm" :visible.sync="registDrawerVisible" direction="rtl" custom-class="regist_drawer" ref="drawer" :size="drawerSize">
      <div class="drawer_content">
        <el-form :model="registInfo" :rules="registRule" ref="registForm" label-position="right" label-width="80px">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model.trim="registInfo.userName" placeholder="请输入用户名" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="registInfo.password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="relayName">
            <el-input v-model="registInfo.relayName" placeholder="请输入用户真实姓名" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="userSex">
            <el-radio-group v-model="registInfo.userSex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电话" prop="userTel">
            <el-input v-model="registInfo.userTel" placeholder="请输入手机号码" prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="registInfo.email" placeholder="请输入邮箱" prefix-icon="el-icon-message"></el-input>
          </el-form-item>
        </el-form>
        <div class="drawer_footer">
          <el-button type="warning" @click="submitForm('registForm')" :loading="registLoading">{{ registLoading ? '提交中 ...' : '注 册 提 交' }}</el-button>
          <el-button type="primary" @click="resetForm('registForm')">重 置</el-button>
        </div>
      </div>
    </el-drawer>

    <div class="fontletter">
      <span>Copyright © 江苏必得网络有限公司 All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import { login, regist } from '../api/user';
export default {
	name: 'UserLogin',
	data() {
		return {
			userinfo: {
				//登录信息
				userName: '', //用户名
				password: '' //密码
			},
			errorMsg: '', //错误提示信息
			registInfo: {
				//注册信息
				userName: '', //用户名
				password: '', //密码
				relayName: '', //真是姓名
				email: '', //邮箱
				userTel: '', //电话
				userSex: 1 //性别
			},
			userLoginRule: {
				//登录验证
				userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
				password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
			},
			registRule: {
				//表单验证
				userName: [
					{ required: true, message: '用户名不能为空', trigger: 'blur' },
					{
						validator: function (rule, value, callback) {
							if (/^[a-zA-Z]{1}\w{4,11}$/.test(value) == false) {
								callback(new Error('由5到12位字母、数字和下划线组成，开头只能为字母，不区分大小写'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
				],
				password: [
					{ required: true, message: '密码不能为空', trigger: 'blur' },
					{ min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
				],
				relayName: [
					{ required: true, message: '真实姓名不能为空', trigger: 'blur' },
					{ pattern: /^[\u4E00-\u9FA5]+$/, message: '真实姓名只能为中文', trigger: 'blur' }
				],
				userSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
				userTel: [
					{ required: true, message: '请输入电话', trigger: 'blur' },
					{
						validator: function (rule, value, callback) {
							if (/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(value) == false) {
								callback(new Error('请输入正确的手机号'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
				],
				email: [
					{ required: true, message: '邮箱地址不能为空', trigger: 'blur' },
					{
						validator: function (rule, value, callback) {
							if (/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(value) == false) {
								callback(new Error('请输入正确的邮箱地址'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
				]
			},
			registDrawerVisible: false, //注册抽屉显示标识
			registLoading: false,
			drawerSize: '35%'
		};
	},
	methods: {
		//用户登录请求后台处理
		login() {
			this.$refs['loginForm'].validate((valid) => {
				if (valid) {
					login(JSON.stringify(this.userinfo)).then((response) => {
						//console.log(response)
						if (response.data.code === 200) {
							this.$store.commit('saveToken', { token: response.data.token });
							this.$store.commit('saveLoginInfo', { loginInfo: JSON.stringify(response.data.loginInfo) });
							this.$router.push({
								path: '/mainIndex'
							});
						} else {
							this.errorMsg = response.data.msg;
						}
					});
				} else {
					this.$message({
						message: '请完整填写登录信息后重试！',
						type: 'error',
						center: true
					});
				}
			});
		},
		//打开注册抽屉
		openRegistDrawer() {
			//根据浏览器宽度决定抽屉宽度
			if (document.documentElement.clientWidth <= 768) {
				this.drawerSize = '100%';
			} else {
				this.drawerSize = '35%';
			}
			this.registDrawerVisible = true;
		},
		//提交注册信息
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.registLoading = true;
					if (this.registInfo.userSex === '男') {
						this.registInfo.userSex = 1;
					} else if (this.registInfo.userSex === '女') {
						this.registInfo.userSex = 0;
					}
					regist(JSON.stringify(this.registInfo)).then((response) => {
						//console.log(response)
						if (response.data.code === 200) {
							setTimeout(() => {
								this.registDrawerVisible = false;
								this.$refs[formName].resetFields();
								// 动画关闭需要一定的时间
								setTimeout(() => {
									this.registLoading = false;
									this.$notify({
										title: '成功',
										message: '恭喜你注册成功，快去登录吧！',
										type: 'success',
										position: 'top-right',
										offset: 20
									});
								}, 400);
							}, 1000);
						} else if (response.data.code === 304) {
							this.$notify({
								title: '抱歉',
								message: response.data.msg,
								type: 'warning',
								position: 'bottom-right',
								offset: 20
							});
							this.registLoading = false;
						} else if (response.data.code === 500) {
							this.$notify.error({
								title: '系统错误',
								message: response.data.msg,
								position: 'bottom-right',
								offset: 20
							});
							this.registLoading = false;
						}
					});
				} else {
					this.$message({
						message: '注册表单验证失败，请检查您输入的内容！',
						type: 'error'
					});
				}
			});
		},
		//重置注册表单
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		//关闭抽屉提醒
		handleCloseRegistForm(done) {
			this.$refs['registForm'].resetFields();
			done();
		}
	}
};
</script>

<style lang="less" scoped>
.background {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	min-width: 100vw;
	.content {
		width: 450px;
		height: 370px;
		padding-top: 10px;
		border-radius: 15px;
	}
	.blur {
		filter: blur(1rem);
		position: absolute;
		z-index: 1;
	}
	.not-blur {
		border: 1px solid white;
		z-index: 999;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		h1 {
			font-size: 26px;
			color: white;
			font-family: '仿宋';
		}
		.divider {
			width: 80%;
		}
		.formDiv {
			width: 80%;
			margin: 0 auto;
			.error {
				color: red;
				height: 16px;
			}
			.form_btn_div {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.loginFormButton {
					width: 45%;
					margin-top: 20px;
				}
			}
		}
	}
	.el-drawer__wrapper {
		/deep/ .el-drawer {
			background-color: #2d3a4b;
		}
		/deep/ span {
			color: #fff;
		}
		.el-form-item {
			margin-bottom: 9%;
			/deep/ .el-form-item__label {
				color: #fff;
			}
			/deep/ .el-input__inner {
				background-color: #283443;
				border: 1px solid hsla(0, 0%, 100%, 0.1);
				color: #fff;
			}
		}
		.drawer_content {
			padding: 5%;
			.drawer_footer {
				display: flex;
				justify-content: right;
				.el-button:nth-child(1) {
					width: 50%;
				}
				.el-button:nth-child(2) {
					width: 40%;
				}
			}
		}
	}
}
.background,
.content.blur {
	background: linear-gradient(rgba(9, 36, 64, 0.7) 0%, rgba(9, 36, 64, 0.1) 50%, rgba(9, 36, 64, 0.7) 100%), url('../assets/examLoginBg007.jpg');
	background-size: cover;
	background-attachment: fixed;
}

.fontletter {
	position: absolute;
	bottom: 50px;
	font-size: 14px;
	color: #b2b2b2;
}
</style>
